module.exports = __webpack_public_path__ + "img/tab-01.e389913b.png";